function useMyTeamAttendance() {
  return {};
}

export default useMyTeamAttendance;
